<template>
	<div>
		<div v-if="type=='block'" class="flex alcenter">
			<div class="order-t"  v-if="showT.d > 0" :class="size" :style="{background:bgColor,color:color}">{{showT.d}}</div><div v-if="showT.d > 0" class="ft12 ftw600 plr5">天</div>
			<div class="order-t"  :class="size" :style="{background:bgColor,color:color}">{{showT.h}}</div><div class="ft12 ftw600 plr5">:</div>
			<div class="order-t"  :class="size" :style="{background:bgColor,color:color}">{{showT.m}}</div><div class="ft12 ftw600 plr5">:</div>
			<div class="order-t"   :class="size" :style="{background:bgColor,color:color}">{{showT.s}}</div>
		</div>
		<div v-else :class="size">
			{{showT.d ? showT.d + '天' : ''}}{{showT.h}}:{{showT.m}}:{{showT.s}}
		</div>
		
	</div>
</template>

<script>
	import  helper from '../../common/helper.js';
	
	export default{
		props:{
			index:{
				type:Number,
				default:0,
			},
			t:{
				type:Number,
				default:0,
			},
			type:{
				type:String,
				default:'block',
			},
			size:{
				type:String,
				default:''
			},
			bgColor:{
				type:String,
				default:'#2E2F33'
			},
			color:{
				type:String,
				default:'#ffffff'
			}
		},
		data(){
			return {
				myT:0,
				timer:null,
			}
		},
		computed:{
			showT(){
				let myT = this.myT;
				
				return helper.djsFull(myT);
			}
		},
		created(){
			this.myT = this.t;
			this.djs();
		},
		destroyed(){
			if(this.timer != null){
				clearInterval(this.timer);
			}
		},
		methods:{
			djs(){
				if(this.timer){
					clearInterval(this.timer);
				}	
				this.timer = setInterval(()=>{
					if(this.myT == 0){
						this.$emit('overTime',this.index);
						clearInterval(this.timer);
					}else{
						this.myT = this.myT - 1;
					}
				},1000);
			}
		}
	}
</script>

<style>
	.order-t{
		width: 64px;
		height: 16px;
		background:#FFFFFF;
		text-align: center;
		line-height: 16px;
		font-size:12px;
		font-weight: bold;
	}
	
</style>